import Cookies from 'js-cookie';

export default Cookies;

// 获取cookie值
export const getCookie = key => Cookies.get(key);

export const setCookie = (key, data, opt) => {
  Cookies.set(key, data, opt);
};
